<template>
  <div class="number-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      {{ titleName }}
    </div>
    <div class="search-input">
      <div class="search-select">
        <el-date-picker
          v-model="startReportDate"
          type="date"
          style="width: 48%;margin-right: 4%;"
          placeholder="开始日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
        />
        <el-date-picker
          v-model="endReportDate"
          type="date"
          style="width: 48%"
          placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
        />
      </div>

      <div class="search-btn">
        <button class="btn btn-left" @click="clear">清除内容</button>
        <button class="btn btn-right" @click.prevent="searchDevice(1)">查询记录</button>
      </div>
    </div>
    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li
          class="result-item"
          v-for="(item, index) in resultList"
          :key="index"
          @click="getDetail(item.id, item.deviceId)"
        >
          <div class="item-name">设备名:{{item.deviceName}}</div>
          <div class="item-code">创建者:{{item.createUsername}}</div>
          <div class="item-code">工单状态:{{item.type === 1 ? "保养" : "校正"}}</div>
          <div class="item-code">{{item.type === 1 ? "保养" : "校正"}}时间:{{item.time}}</div>
        </li>
      </ul>
      <!-- 底部提示信息 -->
      <transition name="fade">
        <div class="bottom-tip" v-show="isShowTips">
          <span class="loading-hook">{{pullupMsg}}</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  data () {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      titleName: "",
      resultList: [],
      startReportDate: null,
      endReportDate: null,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      devicePositionId: '',
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.endReportDate) {
            return  time.getTime() > new Date(this.endReportDate).getTime()-8.64e7
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.startReportDate) {
            return  time.getTime() < new Date(this.startReportDate).getTime()-8.64e7
          }
        }
      }
    };
  },
  created() {
    this.searchDevice(1);
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回首页
    backIndex() {
      this.$router.replace({ name: 'hyDevicePage' })
    },
    clear () {
      this.startReportDate = null;
      this.endReportDate = null;
    },
    searchDevice (type) {
      this.titleName = "设备维修记录";
      if (type == 1) {
        this.page = 1;
      }
      this.$http.httpGet('/app/laDeviceRepairOrder/list', {
        startTime: this.startReportDate,
        endTime: this.endReportDate,
        page: 1,
        limit: 10
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.data.length == 0) {
            this.$message.info('查无此设备')
          }
          this.resultList = res.data
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll () {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true,
          scrollY: true,
          probeType: 3
        })
        // 一些监听
        this.scroll.on('scroll', (pos) => {
          if (pos.y - this.scroll.maxScrollY < -50) {
            this.isShowTips = true
          } else {
            this.isShowTips = false
          }
        })
        this.scroll.on('touchEnd', pos => {
          // 1.2.1监听下拉
          if (pos.y >= 50) {
            console.log('下拉刷新')
          }
          // 1.2.2监听上拉
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.loading = true
            this.titleName = "设备维修记录";
            // 发请求加载
            this.$http.httpGet('/app/laDeviceRepairOrder/list', {
              startTime: this.startReportDate,
              endTime: this.endReportDate,
              page: this.page,
              limit: 10
            }).then(res => {
              this.loading = false
              if (res.code === 0 && res.msg === 'success') {
                if (res.data.length == 0) {
                  this.$message.info('没有更多数据了')
                  return
                }
                this.page++
                let arr = res.data
                this.resultList = this.resultList.concat(arr)
                this.$nextTick(() => {
                  this.scroll.refresh()
                  this.scroll.finishPullUp()
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else if (!this.$refs.wrapper) {
        return
      }
      else {
        this.scroll.refresh()
      }
    },
    getDetail(id, deviceId) {
      // if (id) {
        this.$router.replace({
          name: "hyedit",
          query: {
            id: id,
            devideid: deviceId
          }
        })
      // } else {
      //   this.$message.error("请选择设备记录信息")
      // }
    },
  },
  mounted () {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  }
}
</script>

<style scoped lang="scss">
//@import '@/assets/style/global.scss';
.number-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .search-input {
    position: relative;
    margin: 0 0 20px;
    overflow: hidden;
    .search-wrapper {
      position: relative;
      padding: 15px 20px;
      .wrapper-input {
        box-sizing: border-box;
        width: calc(100% - 5rem);
        height: 4rem;
        line-height: 4rem;
        border-radius: 6px 0 0 6px;
        border: 1px solid #ddd;
        background-color: #fff;
        // display: inline-block;
        float: left;
        input {
          height: 3rem;
          width: calc(100% - 2rem);
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1.6rem;
          outline-style: none;
          color: #333;
          background-color: transparent;
        }
      }

      .wrapper-icon {
        position: relative;
        background-color: rgba(245, 209, 7, 0.801);
        width: 5rem;
        height: 4rem;
        display: inline-block;
        line-height: 4rem;
        text-align: center;
        border-radius: 0 6px 6px 0;
        a {
          color: #333;
          i {
            font-size: 3rem;
            font-weight: bold;
          }
        }
      }
    }
    .search-select {
      text-align: center;
      padding: 10px 20px;
      .el-select {
        width: 100%;
      }
    }
    .search-btn {
      margin-top: 0;
      padding: 0 20px;
      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }
      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }
      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
    }
  }
  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 140px);
    width: 100%;
    // height: 100%;
    overflow: hidden;
    .result-content {
      padding: 0 20px 10px;
      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 0.5rem;
        margin-bottom: 1.5rem;
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;
        .item-name, .item-code {
          line-height: 1.8;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .item-location {
          height: 1.8rem;
          line-height: 1.8rem;
          font-size: 1.4rem;
          margin-top: 1.4rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .loading {
    position: fixed;
    bottom: 3rem;
    left: 45%;
    span {
      font-size: 1.4rem;
    }
  }
  .bottom-tip {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #333;
    // background: #f2f2f2;
    position: absolute;
    bottom: -5px;
    font-size: 1.6rem;
    left: 0;
  }
}
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
